import { createSelector } from "reselect";

const getEvents = (state) => state.events;
const getHuman = (state, props) => props.human;

export const getHumanEvents = createSelector(
  [getEvents, getHuman],
  (events, human) => {
    const humanEvents = [];
    for (let e of events) {
      if (e.humanId === human.id) humanEvents.push(e);
    }
    humanEvents.sort((a, b) => b.date.localeCompare(a.date));
    return humanEvents;
  }
);
